import { BaseContainerModel } from "../../base-container.model";
import { bl_fi_generic_doc_custom_processing_filter_RowClass } from "../../../dbschema";

export class GenericDocCustomProcessingFilterContainerModel extends BaseContainerModel{
  bl_fi_generic_doc_custom_processing_filter: bl_fi_generic_doc_custom_processing_filter_RowClass = new bl_fi_generic_doc_custom_processing_filter_RowClass();
}
